import { get } from 'svelte/store';
import { ApiTypes } from '../../enums/api.enum';
import {
  addApiError,
  addBusyApi,
  removeBusyApi,
} from '../../helpers/handle-api';
import { state_apiErrors } from '../../store/state';
import { trackedFetch } from '../../telemetry/tracked-fetch';
import { UserStateHelper } from '../../helpers/user-state-helper';
import type { IConfigStore } from '../../interfaces/store-config.interface';

/** Fetch public configuration; supplied tracking metadata opts into POST. */
export async function GetOption(
  configId: string,
  tenantId: string,
  agentId: string,
  apiBaseUrl: string,
  tracking?: IConfigStore['customAttributes']
): Promise<any> {
  try {
    addBusyApi(ApiTypes.getOption);
    state_apiErrors.set(
      get(state_apiErrors).filter((x) => x.apiType !== ApiTypes.getOption)
    );

    let url = new URL(`${apiBaseUrl}/1/option`);

    if (configId) {
      url.searchParams.set('config', configId);
    }

    if (tenantId) {
      url.searchParams.set('tenant', tenantId);
    }

    if (agentId) {
      url.searchParams.set('agent', agentId);
    }

    return trackedFetch(tenantId, url.href, {
      method: tracking === undefined ? 'GET' : 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: tracking === undefined ? undefined : JSON.stringify({
        url: tracking.url || window.location.href,
        user_id: UserStateHelper.getUserId(),
        user_tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
        attributes: tracking.attributes,
        flags: tracking.flags,
      }),
    })
      .then((res) => {
        if (res?.ok) return res;

        throw res;
      })
      .catch((res) => {
        /** error api */
        addApiError({
          apiType: ApiTypes.getOption,
          status: res?.status,
          statusText: res?.statusText,
          error: res?.error,
          errorType: res?.type,
        });

        throw res;
      })
      .finally(() => {
        removeBusyApi(ApiTypes.getOption);
      });
  } catch (e) {
    removeBusyApi(ApiTypes.getOption);
    throw e;
  }
}
